const products = [
    {
      id: 1,
      name: "Chicken Burger",
      price: 4500,
      category: "Burger",
      image: "/vendors/kfc/assets/products/burger.webp",
      inStock: true,
      featured: true,
    },
  
    {
      id: 2,
      name: "Hot Wings",
      price: 3200,
      category: "Chicken",
      image: "/vendors/kfc/assets/products/wings.webp",
      inStock: true,
    },
  ];
  
  export default products;